import { SettingsService, SkinTheme } from './../../../core/services/settings.service';
import { Component, OnInit, ElementRef, ViewChild, Renderer2, HostListener, ChangeDetectionStrategy, Inject } from '@angular/core';
import * as screenfull from 'screenfull';
 
import { Router } from '@angular/router';

import { DOCUMENT, registerLocaleData } from '@angular/common';
import { TranslateService } from '@ngx-translate/core';
import { SysApiService } from 'src/app/core/services/sysapi.service';
import { NzModalService } from 'ng-zorro-antd/modal';
import { NzMessageService } from 'ng-zorro-antd/message';
import { UserTokenService } from 'src/app/core/services/user-token.service';


@Component({
  selector: 'app-layout-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.less'],
  // changeDetection: ChangeDetectionStrategy.OnPush
})


export class HeaderComponent implements OnInit {
  @ViewChild('search') searchInput;
  fullscreenStatus: boolean;
  searchEditing: boolean;
  langs: any[];
  themes:Array<SkinTheme>;
  constructor(
    private router: Router,
    private confirmServ: NzModalService,
    private messageServ: NzMessageService,
    public settings: SettingsService,
    public token:UserTokenService,
    public sysapi: SysApiService,
    private renderer2: Renderer2,
    @Inject(DOCUMENT) private doc: any,
    private translate: TranslateService) {
    this.langs = this.settings.langs;
    this.themes=this.settings.themes;
  }

  ngOnInit(): void {
    if (this.sysapi.isWebkitClient) {
      this.sysapi.registerMoveApp();
    }
  }

  toggleCollapsedSidebar() {
    this.settings.setLayout('collapsed', !this.settings.layout.collapsed);
  }

  onSearchFocus() {
    this.searchEditing = true;
    this.renderer2.addClass(this.searchInput.elementRef.nativeElement, 'header-search-focus');
  }

  onSearchBlur() {
    this.searchEditing = false;
    this.renderer2.removeClass(this.searchInput.elementRef.nativeElement, 'header-search-focus');
  }

   
  setFullScreen() {
    if (screenfull.isEnabled) {
      screenfull.toggle();
    }
  }

  @HostListener('window:resize')
  _resize() {
    if (screenfull.isEnabled) {
      this.fullscreenStatus = screenfull.isFullscreen;
    } else {
      this.fullscreenStatus = false;
    }
  }

  clearLocaCach() {
    this.confirmServ.confirm({
      nzTitle: 'Make sure clear all local storage?',
      nzOnOk: () => {
        localStorage.clear();
        this.messageServ.success('清理成功!');
        this.router.navigate(['/passport/login']);
      },
    });
  }

  logout() {
    this.token.clear();
    localStorage.clear();
    this.settings.firstLogin = true;
    this.router.navigate(['/passport/login']);
  }

  changeLang(lang: string) {
    this.settings.useLang(lang);
    setTimeout(() => this.doc.location.reload());
  }

  changeTheme(theme:string){
    this.settings.useTheme(theme);
  }

}
